import { render, staticRenderFns } from "./PlacementEditor.vue?vue&type=template&id=e94d716a&"
import script from "./PlacementEditor.vue?vue&type=script&lang=ts&"
export * from "./PlacementEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VExpansionPanelContent,VSelect})
